<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"> </p>
<p class="indent"><a id="page_1"><em>Puck flapped his wings hard, but he couldn’t resist the pull of the black, gaping hole above him. He looked like a worm struggling to avoid a hungry catfish’s jaws.</em></a></p><a id="page_1">
<p class="indent"><em>“Hello! We’ve got a problem!” he cried as he flailed in midair.</em></p>
<p class="indent"><em>Sabrina saw he was about to be swallowed and did the only thing she could think to do. She grabbed Puck’s foot as he sailed past, attempting to stop his ascent. Unfortunately, she, too, was jerked off the ground. She cried out, but her grandmother, her uncle, and Mr. Canis were too far away to reach her. Only Sabrina’s sister, Daphne, was nearby. The little girl latched onto Sabrina’s pant leg only to be yanked off the ground as well. Now all three of them were caught in the hole’s swirling gravitational pull.</em></p>
<p class="indent"><em>Puck’s face passed through the event horizon and his head completely disappeared. His upper torso and arms followed, then his waist, and finally his legs. All that was left of him in this world were his sneakers. Sabrina clung to them with all her strength.</em></p>
<p class="indent"><em>“We’re losing him!” Daphne cried desperately.</em></p>
<p class="indent"><em>“Puck, you have to fight it!” Sabrina shouted.</em></p>
<p class="indent"><em>But her own words sounded laughable in Sabrina’s ears. How could he fight something with such power? What could any of them do to save themselves—and soon the rest of the world—from being sucked into nothingness?</em></p>
</a><p class="indent"><a id="page_1"><em>Puck’s shoes disappeared into the hole, though Sabrina could still </em></a><em><a id="page_2">feel them in her hands. She knew if she let go he would be gone forever, so she hung on tight, even as she herself was swallowed. Both her arms sank into the empty, dark pool. She took a deep breath and said a final, silent prayer for her soul, hoping that God would find her on the other side, wherever that might be.</a></em></p><a id="page_2">
<p class="indent"><em>And then the hole quadrupled in size.</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?150d0a51